/* ==========================================================================
   SASH STORE — motion eligibility

   One shared answer to "can this visitor have the motion?", loaded before the
   two motion scripts so both agree.

   The test is CAPABILITY, not CSS width. An earlier version gated on
   window.innerWidth >= 1000, which quietly failed for anyone browsing at high
   browser zoom: at 200% zoom a 1424px window reports 712 CSS px, so a desktop
   with a mouse was treated as a phone and got the flat fallback.

   A fine pointer means a mouse or trackpad, which means a desktop or laptop.
   Phones and tablets report a coarse pointer and keep the flat grid. The width
   floor only rules out genuinely tiny windows.
   ========================================================================== */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var fine = window.matchMedia('(pointer: fine)');
  var conn = navigator.connection || {};

  var lowPower =
    conn.saveData === true ||
    /(^|-)2g$/.test(conn.effectiveType || '') ||
    (navigator.deviceMemory && navigator.deviceMemory <= 2) ||
    (navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 2);

  var FLAT_KEY = 'sash-flat-view';

  function prefersFlat() {
    try { return window.localStorage.getItem(FLAT_KEY) === '1'; } catch (e) { return false; }
  }

  window.SashGate = {
    reduced: reduced,
    fine: fine,
    lowPower: lowPower,
    FLAT_KEY: FLAT_KEY,
    prefersFlat: prefersFlat,
    setFlat: function (v) {
      try { window.localStorage.setItem(FLAT_KEY, v ? '1' : '0'); } catch (e) { /* private mode */ }
    },
    // Ambient motion: hero canvas, reveals, tilt, cursor.
    motionOK: function () {
      return !reduced.matches && !lowPower;
    },
    // The 3D stage and corridor, which need a pointer and some room.
    stageOK: function (minWidth) {
      return !reduced.matches &&
        !lowPower &&
        fine.matches &&
        window.innerWidth >= (minWidth || 680) &&
        !prefersFlat();
    }
  };
})();
